@use "~theme/typographyV2" as typography;
@use "~theme/breakpoints";

$round-bottom: 0 0 4px 4px;

.doctorPanel {
  display: flex;
  margin: 20px auto;
  width: fit-content;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid var(--gray-04);
  box-shadow: 0 2px 6px var(--gray-03);
  background-color: var(--white);
}

.carousel {
  display: flex;
  flex-flow: row nowrap;
  max-width: 860px;
  background-color: var(--white);
  overflow-x: auto;
  cursor: pointer;
  position: relative;
  white-space: nowrap;
  scroll-snap-type: x mandatory;
}

.nav {
  width: 40px;
  display: flex;
  background-color: var(--blue-03);
  flex: 1;
  outline: none;
  border: none;
  justify-content: center;
  align-items: center;
  margin: 8px;
  cursor: pointer;

  &:focus-within {
    filter: drop-shadow(0 0 12px var(--hightlight-blue));
  }
}

.nav:active,
.nav:hover {
  outline: none;
}

.navDisabled {
  background-color: var(--gray-04);
  cursor: auto;
}

.doctors {
  cursor: pointer;
  display: flex;
  position: relative;
  width: fit-content;

  // Gray track in which the active doctor "indicator" sits.
  &::after {
    position: absolute;
    content: "";
    top: 0;
    left: 4px;
    right: 4px;
    height: 4px;
    border-radius: $round-bottom;
    background-color: var(--gray-03);
  }
}

.button {
  background-color: var(--blue-01);
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.navDisabled .button {
  background-color: var(--gray-01);
}

.buttonLeft {
  margin-left: 4px;
}

.buttonRight {
  margin-right: 4px;
}

.noAvailableDoctors {
  font-size: 18px;
  font-weight: 600;
  line-height: 140%;
  letter-spacing: 0.02em;
  color: var(--black);
  width: 100%;
  text-align: center;
  background: var(--white);
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;
  font-family: typography.$font-mont;

  p {
    max-width: 100%;
    margin: 50px 24%;
    text-align: center;
    padding: 0;
  }

  a {
    text-decoration: underline;
    cursor: pointer;
  }
}

.doctorSlotsContainer {
  background: var(--white);
  border: 1px solid var(--gray-03);
  border-radius: 24px;
  box-shadow: 0 2px 6px var(--gray-03);
  overflow: hidden;

  @media screen and (max-width: 991px) {
    border-radius: 16px;
  }
}

.doctorTimeSlotContainer{
    background: var(--white);
    border: none;
    border-bottom: 1px solid var(--gray-03);
    border-radius: 0;
    padding: 12px 16px;
    display: block;
    overflow: auto;

    &:last-child {
      border-bottom: none;
    }

    @media screen and (max-width: 991px) {
      display: grid;
      grid-template-columns: minmax(0, 1fr);
      overflow: hidden;
      padding: 16px 12px;
    }
}

.contentLeft {
    width:25%;
    float:left;
    height: 100%;
    max-height: 100%;

    @media screen and (max-width: 991px) {
      float: none;
      width: 100%;

      > div {
        align-items: start;
        column-gap: 12px;
        display: grid;
        grid-template-columns: 48px minmax(0, 1fr);
        margin-bottom: 12px;

        > :first-child {
          grid-row: 1 / span 4;
        }
      }
    }
}

.contentRight {
    width:75%;
    float:left;
    height: 100%;
    max-height: 100%;

    @media screen and (max-width: 991px) {
      float: none;
      min-width: 0;
      width: 100%;
    }
}

.avatar {
  border-radius: 50%;
  width: 74px;
  height: 74px;
  background-size: 74px;
  background-color: var(--blue-02-at-30);
}

.small {
    width: 48px;
    height: 48px;
}

.limitedAvailability{
  width: 100%;
  height: 150px;
  background: var(--white);
  border: none;
  border-bottom: 1px solid var(--gray-03);
  border-radius: 0;
  float: none;
  padding: 12px 16px;
  margin: 0;

  &:last-child {
    border-bottom: none;
  }
}

.divHidden{
  display:none;
}

.marginLeft {
  margin-left: 0px;
}

.marginRight {
  margin-right: 0px;
}

.mobileDivider {
  border-bottom: 1px solid var(--gray-03);
  margin: 12px 0;
}

.borderDivider {
  border: 1px solid rgba(0, 51, 102, 0.3);
  display: block;
  overflow: auto;
  @include breakpoints.desktop {
    display: none;
  }
}